/*****************************************************************************
 *
 * Trivial utility methods that return text or variable fields based on
 * the selected cost
 *
 *****************************************************************************/

import {COSTS, VARIABLES} from "./constants";
import {TEXT, VARIABLE_LABELS_LONG} from "./strings";
import * as COLUMNS from "./columns";

export const getStateSectionTitle = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return TEXT.state_title_nonfatal;
    case COSTS.FATAL:
      return TEXT.state_title_fatal;
    case COSTS.TOTAL:
    default:
      return TEXT.state_title_total;
  }
}

export const getCountySectionTitle = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return TEXT.county_title_nonfatal;
    case COSTS.FATAL:
      return TEXT.county_title_fatal;
    case COSTS.TOTAL:
    default:
      return TEXT.county_title_total;
  }
}

export const getSectionFootnote = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return TEXT.footnote_nonfatal;
    case COSTS.FATAL:
      return TEXT.footnote_fatal;
    case COSTS.TOTAL:
    default:
      return TEXT.footnote_total;
  }
}

export const getMapValueProperty = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return VARIABLES.OUDC_perCapita_quartile;
    case COSTS.FATAL:
      return VARIABLES.FODC_perCapita_quartile;
    case COSTS.TOTAL:
    default:
      return VARIABLES.Cost_perCapita_quartile;
  }
}

export const getLegendValueProperty = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return VARIABLES.OUDC_perCapita;
    case COSTS.FATAL:
      return VARIABLES.FODC_perCapita;
    case COSTS.TOTAL:
    default:
      return VARIABLES.Cost_perCapita;
  }
}

export const getLegendValueTitle = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return VARIABLE_LABELS_LONG.OUDC_perCapita;
    case COSTS.FATAL:
      return VARIABLE_LABELS_LONG.FODC_perCapita;
    case COSTS.TOTAL:
    default:
      return VARIABLE_LABELS_LONG.Cost_perCapita;
  }
}

export const getDetailColumns = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return COLUMNS.NONFATAL_DETAIL_COLUMNS;
    case COSTS.FATAL:
      return COLUMNS.FATAL_DETAIL_COLUMNS;
    case COSTS.TOTAL:
    default:
      return COLUMNS.TOTAL_DETAIL_COLUMNS;
  }
}

export const getSelectionColumns = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return COLUMNS.NONFATAL_SELECTION_COLUMNS;
    case COSTS.FATAL:
      return COLUMNS.FATAL_SELECTION_COLUMNS;
    case COSTS.TOTAL:
    default:
      return COLUMNS.TOTAL_SELECTION_COLUMNS;
  }
}

export const getExportColumns = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return COLUMNS.NONFATAL_EXPORT_COLUMNS;
    case COSTS.FATAL:
      return COLUMNS.FATAL_EXPORT_COLUMNS;
    case COSTS.TOTAL:
    default:
      return COLUMNS.TOTAL_EXPORT_COLUMNS;
  }
}

export const getStateExportTitle = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return TEXT.state_export_title_nonfatal;
    case COSTS.FATAL:
      return TEXT.state_export_title_fatal;
    case COSTS.TOTAL:
    default:
      return TEXT.state_export_title_total;
  }
}

export const getCountyExportTitle = (cost) => {
  switch (cost) {
    case COSTS.NONFATAL:
      return TEXT.county_export_title_nonfatal;
    case COSTS.FATAL:
      return TEXT.county_export_title_fatal;
    case COSTS.TOTAL:
    default:
      return TEXT.county_export_title_total;
  }
}
